var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"app-box"},[_c('NavTop'),_c('div',{staticClass:"centerBox",style:(`backgroundImage:url(${_vm.$utils.getPng('darenNewBg2')})`)},[_c('div',{staticClass:"app-bottom"},[_c('NavLeft'),_c('div',{ref:"scrollBox",staticClass:"app-bottom-right"},[_c('router-view')],1)],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }